import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';

export interface ITransaction {
    id: string;
    valor: number;
    data: string;
    tipo: string;
    status: string;
    descricao?: string;
}

export interface ITransactionFilters {
    startDate: string;
    endDate: string;
    dateType: number;
    accountId: string;
    cnpjNumber?: string;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantTransactionsService {
    private readonly baseUrl = `${API_PATH}merchants/transactions`;

    constructor(private httpClient: HttpClient) { }
    getTransactions(filters: ITransactionFilters): Observable<ITransaction[]> {

        const requestBody = filters;

        const url = this.baseUrl;

        return this.httpClient.post<ITransaction[]>(
            url,       
            requestBody 
        );
    }
}
